const updateUserId = (state, { payload }) => {
	state.userId = payload;
};

export default updateUserId;
